

































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IStore, IFetchRequest, IFetchResult } from '../api/store.interface';
import { StoreEventBus, SHOW_FETCH_RESULTS } from '@/features/stores/api/store.event';

@Component({
  name: 'storeFetchDialog',
  components: {},
})
export default class StoreFetchDialog extends Vue {
  @Getter('store/fetchResults') fetchResults: IFetchResult[];

  show: boolean = false;

  mounted() {
    StoreEventBus.$on(SHOW_FETCH_RESULTS, () => {
      this.show = true;
    });
  }
}
